import axios from 'axios';
import authHeader from "@/service/auth-header";

class TeamService {

    async getTeamForCompany(companyId) {
        return await axios.get(`/api/user/company/all/${companyId}`, {headers: authHeader()})
    }

    async createTeamMember(companyId, data) {
        return await axios.post(`/api/user/${companyId}`, data, {headers: authHeader()});
    }

    async updateTeamMember(id, data) {
        return await axios.put(`/api/user/${id}`, data, {headers: authHeader()});
    }

    async deleteTeamMember(id) {
        return await axios.delete(`/api/user/${id}`, {headers: authHeader()})
    }

    searchCompanyTeam(companyId, searchCriteria) {
        console.log("[BankAccountService][searchCompanyBankAccounts] Before getting bank accounts. Company ID = ", companyId);
        return axios.get(`/api/user/${companyId}/${searchCriteria}`, {headers: authHeader()})
    }

}

export default new TeamService();
